/* Šta glavna pretraga sme da traži i šta radi kad nešto nađeš.

   Izdvojeno u zaseban fajl jer isti spisak čitaju TRI mesta: polje za pretragu
   (koje izvore da pita), dijalog podešavanja (šta operater bira) i sama mapa
   (koju radnju da izvrši na izbor). Da je spisak u komponenti, treće mesto bi
   ga nužno prepisalo i vremenom razišlo.

   Vrednosti su kratki kodovi, ne prevodi — u bazu se upisuje kod, a prevod se
   traži tek pri iscrtavanju. Zato promena jezika ne dira sačuvana podešavanja. */

export const IZVOR = {
    VOZAC:    'VOZAC',
    VOZILO:   'VOZILO',
    LOKACIJA: 'LOKACIJA',
    ADRESA:   'ADRESA',
};

/* Boja po izvoru se ne bira slučajno: plava je već boja rute na mapi, pa je
   dobija vozilo; zelena je „mesto koje postoji", narandžasta „mesto sa mape
   koje još nije naše". Time rezultat ima značenje i pre nego što se pročita. */
export const IZVORI = [
    { kljuc: IZVOR.VOZAC,    naziv: 'gps.pretragaVozac',    ikona: 'pi pi-user',        boja: '#6a1b9a' },
    { kljuc: IZVOR.VOZILO,   naziv: 'gps.pretragaVozilo',   ikona: 'pi pi-truck',       boja: '#1565c0' },
    { kljuc: IZVOR.LOKACIJA, naziv: 'gps.pretragaLokacija', ikona: 'pi pi-map-marker',  boja: '#2e7d32' },
    { kljuc: IZVOR.ADRESA,   naziv: 'gps.pretragaAdresa',   ikona: 'pi pi-map',         boja: '#ef6c00' },
];

/* Radnja koja se izvršava kad operater izabere rezultat — jedna po izvoru.
   `uPripremi` stavke se vide ali se ne mogu izabrati: korisnik traži gde su,
   pa je pošteno pokazati da dolaze, umesto ih sakriti. */
export const AKCIJE = {
    [IZVOR.VOZAC]: [
        { kljuc: 'CHAT',        naziv: 'gps.akcijaRazgovor' },
        { kljuc: 'PODESAVANJA', naziv: 'gps.akcijaPodesavanja' },
        { kljuc: 'IZVESTAJ14',  naziv: 'gps.akcijaIzvestaj14' },
    ],
    [IZVOR.VOZILO]: [
        { kljuc: 'PUTANJA',     naziv: 'gps.akcijaPutanja' },
        { kljuc: 'PODESAVANJA', naziv: 'gps.akcijaPodesavanja' },
        { kljuc: 'IZVESTAJ14',  naziv: 'gps.akcijaIzvestaj14' },
    ],
    [IZVOR.LOKACIJA]: [
        { kljuc: 'KARTA',       naziv: 'gps.akcijaKarta' },
        { kljuc: 'NALOG',       naziv: 'gps.akcijaNalog',     uPripremi: true },
        { kljuc: 'BRZI_NALOG',  naziv: 'gps.akcijaBrziNalog', uPripremi: true },
    ],
    [IZVOR.ADRESA]: [
        { kljuc: 'KARTA',       naziv: 'gps.akcijaKarta' },
        { kljuc: 'KLIJENT',     naziv: 'gps.akcijaDodajKlijenta' },
        { kljuc: 'NALOG',       naziv: 'gps.akcijaNalog',     uPripremi: true },
        { kljuc: 'BRZI_NALOG',  naziv: 'gps.akcijaBrziNalog', uPripremi: true },
    ],
};

/* Podrazumevano je sve uključeno i svaka radnja je ona najbezopasnija —
   pokaži, ne menjaj. Operater koji ništa ne podesi ne sme da klikne na
   rezultat i nehotice napravi zapis u bazi. */
export const PODRAZUMEVANO = {
    izvori: [IZVOR.VOZAC, IZVOR.VOZILO, IZVOR.LOKACIJA, IZVOR.ADRESA],
    akcije: {
        [IZVOR.VOZAC]:    'CHAT',
        [IZVOR.VOZILO]:   'PUTANJA',
        [IZVOR.LOKACIJA]: 'KARTA',
        [IZVOR.ADRESA]:   'KARTA',
    },
};

/* Zapis u bazi je kratak namerno: config.PodesavanjaOperatera.vrednost je
   NVARCHAR(200), pa se čuvaju samo `i` (izvori) i `a` (akcije). Čitanje je
   popustljivo — nepoznat ili pokvaren zapis se tiho vraća na podrazumevano,
   jer je ostati bez pretrage gore od izgubljene postavke. */
export const upakuj = (izbor) => JSON.stringify({ i: izbor.izvori, a: izbor.akcije });

export const raspakuj = (tekst) => {
    if (!tekst) return PODRAZUMEVANO;
    try {
        const p = JSON.parse(tekst);
        const izvori = Array.isArray(p.i)
            ? p.i.filter(x => IZVORI.some(iz => iz.kljuc === x))
            : PODRAZUMEVANO.izvori;
        const akcije = { ...PODRAZUMEVANO.akcije };
        Object.keys(p.a || {}).forEach(k => {
            if (AKCIJE[k] && AKCIJE[k].some(a => a.kljuc === p.a[k])) akcije[k] = p.a[k];
        });
        return { izvori: izvori.length ? izvori : PODRAZUMEVANO.izvori, akcije };
    } catch (e) {
        return PODRAZUMEVANO;
    }
};
